import axios from 'axios'
const state = () => ({
    category: []
})

const getters = {
    category(state) {
        return state.category
    }
}

const mutations = {
    SET_CATEGORY(state, payload){
        state.category = payload
    },
}

const actions = {
    getCategory({commit}, payload){
        axios.post(`https://rtam.uz/api/categories/list-search`, payload)
            .then((res)=>{
                commit("SET_CATEGORY", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
